
import React, { useState, useEffect } from 'react';

import { useAuth } from '../../../../../AuthContext';
import { useNavigate } from 'react-router-dom';

import './CoursesInPlace.css';

import bazeleconta from '../../../images/bazeleconta.png';
import contafinanciaraone from '../../../images/contafinanciara.png';
import contaprimara from '../../../images/contaprimara.png';
import contabilitateaplicata from '../../../images/contabilitateaplicata.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faChevronRight,
  faCrown,
  faLock,
} from '@fortawesome/free-solid-svg-icons';

/* ==========================================
   LISTA CURSURI
========================================== */

const mockCourses = [
  {
    id: 1,
    name: 'Bazele contabilitatii',
    description: 'Fundamentele contabilitatii pe intelesul tuturor.',
    status: 'active',
    access: 'free',
    icon: bazeleconta,
    color: 'teal',
  },
  {
    id: 2,
    name: 'Contabilitate financiara',
    description: 'Invata sa inregistrezi si sa intelegi operatiunile financiare.',
    status: 'active',
    access: 'premium',
    icon: contafinanciaraone,
    color: 'orange',
  },
  {
    id: 3,
    name: 'Contabilitate primara',
    description: 'Invata documentele si operatiunile contabile de baza.',
    status: 'In dezvoltare',
    access: 'premium',
    icon: contaprimara,
    color: 'green',
  },
  {
    id: 4,
    name: 'Contabilitate aplicata',
    description: 'Aplica notiunile contabile in situatii practice si exercitii.',
    status: 'In dezvoltare',
    access: 'premium',
    icon: contabilitateaplicata,
    color: 'purple',
  },
];

/* ==========================================
   VERIFICARE DISPONIBILITATE
========================================== */

const isCourseAvailable = (course, isPremium) => {
  if (!course || course.status !== 'active') {
    return false;
  }

  if (course.access === 'premium' && !isPremium) {
    return false;
  }

  return true;
};

/* ==========================================
   COMPONENTA PRINCIPALA
========================================== */


export default function CoursesInPlace() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [isPremium, setIsPremium] = useState(
    user?.is_premium === true
  );

  // Verifica Premium direct din backend
  useEffect(() => {
    let cancelled = false;

    const fetchPremiumStatus = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/user`,
          {
            method: 'GET',
            credentials: 'include',
          }
        );

        if (!response.ok) return;

        const data = await response.json();

        if (!cancelled) {
          setIsPremium(data?.is_premium === true);
        }
      } catch (error) {
        console.error(
          'Eroare verificare Premium in CoursesInPlace:',
          error
        );
      }
    };

    fetchPremiumStatus();

    return () => {
      cancelled = true;
    };
  }, []);

  // Sincronizare cand AuthContext se actualizeaza
  useEffect(() => {
    if (typeof user?.is_premium === 'boolean') {
      setIsPremium(user.is_premium);
    }
  }, [user?.is_premium]);


  /* ==========================================
     CURSURI INSCRISE
  ========================================== */

  const [enrolledCourses, setEnrolledCourses] = useState(() => {
    const saved = localStorage.getItem('enrolledCourses');

    if (saved) {
      try {
        const parsed = JSON.parse(saved);

        if (Array.isArray(parsed)) {
          // doar cursuri active; fara Premium pastram doar cursul gratuit (localStorage nu e de incredere)
          return [...new Set(parsed.map(Number))].filter((id) =>
            isCourseAvailable(
              mockCourses.find((course) => course.id === id),
              isPremium
            )
          );
        }
      } catch {
        return [1];
      }
    }

    return [1];
  });

  /* ==========================================
     SALVARE CURSURI ACTIVE
  ========================================== */

  useEffect(() => {
    localStorage.setItem(
      'enrolledCourses',
      JSON.stringify(enrolledCourses)
    );

    window.dispatchEvent(
      new CustomEvent('coursesUpdated', {
        detail: enrolledCourses,
      })
    );
  }, [enrolledCourses]);

  /* ==========================================
     ADAUGARE / ELIMINARE CURS
  ========================================== */

  const handleToggleEnroll = (event, courseId) => {
    event.stopPropagation();

    const numericCourseId = Number(courseId);

    const course = mockCourses.find(
      (item) => item.id === numericCourseId
    );

    // Cursurile in dezvoltare nu pot fi adaugate.
    if (!isCourseAvailable(course, isPremium)) {
      return;
    }

    setEnrolledCourses((currentCourses) => {
      if (currentCourses.includes(numericCourseId)) {
        return currentCourses.filter(
          (id) => id !== numericCourseId
        );
      }

      return [...currentCourses, numericCourseId];
    });
  };

  /* ==========================================
     SELECTARE CURS
  ========================================== */

  const handleCourseClick = (course) => {
    // Blocheaza orice curs care nu este activ.
    if (!isCourseAvailable(course, isPremium)) {
      return;
    }

    const courseId = Number(course.id);

    if (![1, 2, 3, 4].includes(courseId)) {
      return;
    }

    if (!enrolledCourses.includes(courseId)) {
      setEnrolledCourses((currentCourses) => {
        if (currentCourses.includes(courseId)) {
          return currentCourses;
        }

        return [...currentCourses, courseId];
      });
    }

    localStorage.setItem(
      'selectedCourseId',
      String(courseId)
    );

    window.dispatchEvent(
      new CustomEvent('courseSelected', {
        detail: courseId,
      })
    );
  };

  /* ==========================================
     INTERFATA
  ========================================== */

  return (
    <div className="courses-page-layout">
      <main className="courses-page-main">

        {/* HEADER */}

        <div className="coursesinplace-header">
          <h1>Cursurile mele</h1>
          <p>Alege cursul pe care vrei sa il continui.</p>
        </div>

        {/* GRID CURSURI */}

        <div className="coursesinplace-grid">
          {mockCourses.map((course) => {

            const isEnrolled =
              enrolledCourses.includes(course.id);

            const isActive =
              course.status === 'active';

            const isInDevelopment =
              !isActive;

            const isPremiumCourse =
              course.access === 'premium';

            const isLocked =
              isActive && isPremiumCourse && !isPremium;

            const canClick =
              isCourseAvailable(course, isPremium);
              const canOpenCard = canClick || isLocked;

            const colorClass =
              course.color
                ? `color-${course.color}`
                : '';

            return (
              <div
                key={course.id}
                className={[
                  'coursesinplace-card',

                  isActive ? 'current' : '',

                  isInDevelopment
                    ? 'in-development'
                    : '',

                  isPremiumCourse && isActive
                    ? 'premium-course'
                    : '',

                  !isPremiumCourse && isActive
                    ? 'free-course'
                    : '',

                  isLocked ? 'premium-locked' : '',

                  colorClass,
                ].filter(Boolean).join(' ')}

             
onClick={() => {
  if (isLocked) {
    navigate('/premium/plans');
    return;
  }

  if (canClick) {
    handleCourseClick(course);
  }
}}

role={canOpenCard ? 'button' : undefined}

tabIndex={canOpenCard ? 0 : undefined}

aria-disabled={!canOpenCard}

onKeyDown={(event) => {
  if (
    event.key !== 'Enter' &&
    event.key !== ' '
  ) {
    return;
  }

  if (!canOpenCard) return;

  event.preventDefault();

  if (isLocked) {
    navigate('/premium/plans');
    return;
  }

  handleCourseClick(course);
}}

style={{
  cursor: canOpenCard ? 'pointer' : 'default',
}}

              >

                {/* BADGE PREMIUM */}

                {isPremiumCourse && isActive && (
                  <div className="coursesinplace-premium-badge">
                    <FontAwesomeIcon
                      icon={faCrown}
                      aria-hidden="true"
                    />
                    <span>Premium</span>
                  </div>
                )}

                {/* STATUS CURS */}

                {isInDevelopment ? (

                  <div
                    className="coursesinplace-development-badge"
                    title="Acest curs este in dezvoltare"
                  >
                    In dezvoltare
                  </div>

                ) : isLocked ? (

                  <div
                    className="coursesinplace-lock-badge"
                    title="Disponibil cu Premium"
                  >
                    <FontAwesomeIcon
                      icon={faLock}
                      aria-hidden="true"
                    />
                  </div>

                ) : isEnrolled ? (

                  <button
                    type="button"
                    className="coursesinplace-current-badge"
                    onClick={(event) =>
                      handleToggleEnroll(event, course.id)
                    }
                    aria-label={`Elimina ${course.name} din cursurile mele`}
                    title="Elimina cursul"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M7 10L9 12L13 8"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>

                ) : (

                  <button
                    type="button"
                    className="coursesinplace-add-badge"
                    onClick={(event) =>
                      handleToggleEnroll(event, course.id)
                    }
                    aria-label={`Adauga ${course.name} in cursurile mele`}
                    title="Adauga cursul"
                  />

                )}

                {/* IMAGINE CURS */}

                <div
                  className={[
                    'coursesinplace-card-icon',
                    isActive ? 'current' : '',
                    isPremiumCourse && isActive
                      ? 'premium-course'
                      : '',
                    colorClass,
                  ].filter(Boolean).join(' ')}
                >
                  <img
                    src={course.icon}
                    alt={course.name}
                    className="coursesinplace-course-image"
                  />
                </div>

                {/* CONTINUT CURS */}

                <div className="coursesinplace-card-content">
                  <div
                    className={[
                      'coursesinplace-card-title',
                      isActive ? 'current' : '',
                    ].filter(Boolean).join(' ')}
                  >
                    {course.name}
                  </div>

                 
<div className="coursesinplace-card-description">
  {course.description}
</div>

{isLocked && (
  <button
    type="button"
    className="coursesinplace-try-premium"
    onClick={(event) => {
      event.stopPropagation();
      navigate('/premium/plans');
    }}
  >
    Incearca Premium
  </button>
)}

                </div>

                {/* SAGEATA */}

                {canClick && (
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="coursesinplace-card-arrow"
                    aria-hidden="true"
                  />
                )}

              </div>
            );
          })}
        </div>

      </main>
    </div>
  );
}
